module.exports = __webpack_public_path__ + "img/office-blue.2813c161.png";